import { IoMdRadioButtonOff, IoMdRadioButtonOn } from "react-icons/io"

export default function CourseStructure({ setApplicationState, applicationPiece }) {
  /**
    courseDuration: 0, // in months
    courseContentHours: 0,
    weeklyDaySchedule: '',
   */
  return (
    <>
      <h5>Content Delivery Status?</h5>
      <p>Whether the course will be recorded, live, or hybrid.</p>
      <div className="intended-learners-wr">
        <div className="intended-learners-wr-inner" style={{display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:"12px"}}>
          <label style={{ background: applicationPiece.contentDeliveryStatus === "live" && "#f7f8fe", border: applicationPiece.contentDeliveryStatus === "live" && "3px solid black" }} onClick={() => { setApplicationState(prev => ({ ...prev, coursePlan: { ...prev.coursePlan, contentDeliveryStatus: "live" } })) }} className="custom-radio-label" for="id--570">
            <input type="radio" id="id--570" style={{ position: 'absolute' }} />
            {applicationPiece.contentDeliveryStatus === "live" ? <IoMdRadioButtonOn style={{ color: "#000" }} size={24} /> : <IoMdRadioButtonOff size={24} style={{ color: "#000" }} />}
            <div>live</div>
          </label>

          <label style={{ background: applicationPiece.contentDeliveryStatus === "recorded" && "#f7f8fe", border: applicationPiece.contentDeliveryStatus === "recorded" && "3px solid black" }} onClick={() => { setApplicationState(prev => ({ ...prev, coursePlan: { ...prev.coursePlan, contentDeliveryStatus: "recorded" } })) }} className="custom-radio-label" for="id--571">
            <input type="radio" id="id--571" style={{ position: 'absolute' }} />
            {applicationPiece.contentDeliveryStatus === "recorded" ? <IoMdRadioButtonOn style={{ color: "#000" }} size={24} /> : <IoMdRadioButtonOff size={24} style={{ color: "#000" }} />}
            <div>recorded</div>
          </label>

          <label style={{ background: applicationPiece.contentDeliveryStatus === "hybrid" && "#f7f8fe", border: applicationPiece.contentDeliveryStatus === "hybrid" && "3px solid black" }} onClick={() => { setApplicationState(prev => ({ ...prev, coursePlan: { ...prev.coursePlan, contentDeliveryStatus: "hybrid" } })) }} className="custom-radio-label" for="id--572">
            <input type="radio" id="id--572" style={{ position: 'absolute' }} />
            {applicationPiece.contentDeliveryStatus === "hybrid" ? <IoMdRadioButtonOn style={{ color: "#000" }} size={24} /> : <IoMdRadioButtonOff size={24} style={{ color: "#000" }} />}
            <div>hybrid</div>
          </label>
        </div>
      </div>
      <h5>Course Duration</h5>
      <p>How long will this course take to finish the curriculum?</p>
      <div className="intended-learners-wr">
        <input onChange={(e)=>{setApplicationState(prev=>({...prev, coursePlan: {...prev.coursePlan, courseDuration: e.target.value}}))}} value={applicationPiece.courseDuration} placeholder="Example: 1 month, 0-3 months, 6 months" type="text" />
      </div>
      <h5>Total Content Duration (Hours)</h5>
      <p>How many hours of content does this course deliver?</p>
      <div className="intended-learners-wr">
        <input onChange={(e)=>{setApplicationState(prev=>({...prev, coursePlan: {...prev.coursePlan, courseContentHours: e.target.value}}))}} value={applicationPiece.courseContentHours} placeholder="Example: 10, 12, 34 hours" type="number" />
      </div>
      <h5>Weekly Schedule</h5>
      <p>On which days of the week are you planning to schedule the lectures?</p>
      <div className="intended-learners-wr">
        <input onChange={(e)=>{setApplicationState(prev=>({...prev, coursePlan: {...prev.coursePlan, weeklyDaySchedule: e.target.value}}))}} value={applicationPiece.weeklyDaySchedule} placeholder="Example: MWF, TTF, All Days" type="text" />
      </div>
    </>
  )
}